/* ============================================================
   NAV DRAWER
   Erahaus Shopify Theme for Scent of Qui
   ============================================================ */

(function () {
  'use strict';

  var cleanupNav = null;
  var editorHeaderState = null;

  function getSectionElement(target, selector) {
    if (target && target.matches && target.matches(selector)) return target;
    if (target && target.querySelector) {
      var sectionElement = target.querySelector(selector);
      if (sectionElement) return sectionElement;
    }
    return document.querySelector(selector);
  }

  function captureEditorHeaderState(target) {
    if (typeof Shopify === 'undefined' || !Shopify.designMode) return;

    var header = getSectionElement(target, '.js-site-header');
    var brandName = getSectionElement(target, '.js-brand-name');
    if (!header) return;

    var headerStyle = window.getComputedStyle(header);
    var brandStyle = brandName ? window.getComputedStyle(brandName) : null;

    editorHeaderState = {
      classes: ['is-visible', 'is-light', 'is-scrolled', 'is-footer'].filter(function (className) {
        return header.classList.contains(className);
      }),
      opacity: headerStyle.opacity,
      brandOpacity: brandStyle ? brandStyle.opacity : null,
      brandTransform: brandStyle ? brandStyle.transform : null,
    };
  }

  function restoreEditorHeaderState() {
    if (!editorHeaderState) return;

    var header = document.querySelector('.js-site-header');
    var brandName = document.querySelector('.js-brand-name');
    if (!header) return;

    ['is-visible', 'is-light', 'is-scrolled', 'is-footer'].forEach(function (className) {
      header.classList.toggle(className, editorHeaderState.classes.indexOf(className) !== -1);
    });

    header.style.opacity = editorHeaderState.opacity;

    if (brandName && editorHeaderState.brandOpacity !== null) {
      brandName.style.opacity = editorHeaderState.brandOpacity;
      brandName.style.transform = editorHeaderState.brandTransform;
    }

    editorHeaderState = null;
  }

  function isHeaderSectionTarget(target) {
    return target && (
      (target.matches && target.matches('.js-site-header, .js-nav-drawer')) ||
      (target.querySelector && target.querySelector('.js-site-header, .js-nav-drawer'))
    );
  }

  function destroyNav() {
    if (!cleanupNav) return;
    cleanupNav();
    cleanupNav = null;
  }

  function initNav() {
    destroyNav();

    if (document.body.classList.contains('is-exhibition-mode')) return;

    var burger  = document.querySelector('.js-header-burger');
    var drawer  = document.querySelector('.js-nav-drawer');
    var overlay = document.querySelector('.js-nav-overlay');
    var close   = document.querySelector('.js-nav-close');

    if (!burger || !drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    document.body.classList.remove('menu-open');

    function openMenu() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('menu-open');
      if (window.__lenis) window.__lenis.stop();
      if (close) close.focus();
    }

    function closeMenu() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('menu-open');
      if (window.__lenis) window.__lenis.start();
      burger.focus();
    }

    var onBurgerClick = openMenu;
    var onCloseClick  = closeMenu;
    var onOverlayClick = closeMenu;
    var onKeydown = function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeMenu();
      }
    };

    burger.addEventListener('click', onBurgerClick);

    if (close) close.addEventListener('click', onCloseClick);

    if (overlay) overlay.addEventListener('click', onOverlayClick);

    document.addEventListener('keydown', onKeydown);

    cleanupNav = function () {
      burger.removeEventListener('click', onBurgerClick);
      if (close) close.removeEventListener('click', onCloseClick);
      if (overlay) overlay.removeEventListener('click', onOverlayClick);
      document.removeEventListener('keydown', onKeydown);

      if (drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('menu-open');
        if (window.__lenis) window.__lenis.start();
      }
    };
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (!isHeaderSectionTarget(e.target)) return;
    captureEditorHeaderState(e.target);
    destroyNav();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (!isHeaderSectionTarget(e.target)) return;
    restoreEditorHeaderState();
    initNav();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNav);
  } else {
    initNav();
  }

})();
